import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74'),
	() => import('./nodes/75'),
	() => import('./nodes/76'),
	() => import('./nodes/77'),
	() => import('./nodes/78'),
	() => import('./nodes/79'),
	() => import('./nodes/80'),
	() => import('./nodes/81'),
	() => import('./nodes/82'),
	() => import('./nodes/83'),
	() => import('./nodes/84'),
	() => import('./nodes/85'),
	() => import('./nodes/86'),
	() => import('./nodes/87'),
	() => import('./nodes/88'),
	() => import('./nodes/89'),
	() => import('./nodes/90'),
	() => import('./nodes/91')
];

export const server_loads = [];

export const dictionary = {
		"/": [5],
		"/app": [6,[2]],
		"/app/108-heures": [7,[2]],
		"/app/abonnement": [8,[2]],
		"/app/classe": [9,[2]],
		"/app/coloriage": [10,[2]],
		"/app/evaluations": [11,[2]],
		"/app/issr": [12,[2]],
		"/app/plan-de-classe": [13,[2]],
		"/app/progressions": [14,[2]],
		"/app/sequences": [15,[2]],
		"/cahier-journal": [16],
		"/contact": [17],
		"/cycle-1-maternelle": [18],
		"/cycle-2-cp-ce1-ce2": [19],
		"/cycle-3-cm1-cm2": [20],
		"/fiches-exercices": [21,[3]],
		"/fiches-exercices/addition-ce1": [23,[3]],
		"/fiches-exercices/addition": [22,[3]],
		"/fiches-exercices/ce2": [24,[3]],
		"/fiches-exercices/conjugaison": [25,[3]],
		"/fiches-exercices/maternelle-graphisme": [26,[3]],
		"/fiches-exercices/maternelle-nombres": [27,[3]],
		"/fiches-exercices/multiplication-ce1": [28,[3]],
		"/fiches-exercices/multiplication-ce2": [29,[3]],
		"/fiches-exercices/soustraction-ce1": [30,[3]],
		"/fiches-exercices/table-de-multiplication": [31,[3]],
		"/generateur-bulletin": [33],
		"/generateur-evaluation": [34],
		"/generateur-progression-annuelle": [35],
		"/generateur": [32],
		"/guide": [36,[4]],
		"/guide/108-heures-enseignant": [37,[4]],
		"/guide/applications-enseignants-2026": [38,[4]],
		"/guide/appreciations-bulletin-primaire": [39,[4]],
		"/guide/appreciations-lsu": [40,[4]],
		"/guide/attendus-maternelle-2026": [41,[4]],
		"/guide/cahier-journal-en-ligne": [42,[4]],
		"/guide/cahier-journal-enseignant": [43,[4]],
		"/guide/cahier-journal-remplacant": [44,[4]],
		"/guide/differenciation-evaluation-primaire": [45,[4]],
		"/guide/differenciation-pedagogique": [46,[4]],
		"/guide/emploi-du-temps-cp": [47,[4]],
		"/guide/evaluation-mathematiques-ce1": [48,[4]],
		"/guide/evaluation-mathematiques-ce2": [49,[4]],
		"/guide/evaluation-mathematiques-cm1": [50,[4]],
		"/guide/exercices-division-cm1": [51,[4]],
		"/guide/exercices-division-cm2": [52,[4]],
		"/guide/exercices-maths-ce1": [53,[4]],
		"/guide/exercices-maths-ce2": [54,[4]],
		"/guide/exercices-multiplication-ce2": [55,[4]],
		"/guide/fiche-preparation": [56,[4]],
		"/guide/fiche-sequence-maternelle": [57,[4]],
		"/guide/gerer-le-bruit-en-classe": [58,[4]],
		"/guide/gestion-temps-classe": [59,[4]],
		"/guide/histoire-geographie-cm1": [60,[4]],
		"/guide/histoire-geographie-cp": [61,[4]],
		"/guide/ia-enseignement-outils-2026": [62,[4]],
		"/guide/livret-scolaire-unique": [63,[4]],
		"/guide/objectifs-pedagogiques-smart": [64,[4]],
		"/guide/plan-de-classe-vierge": [66,[4]],
		"/guide/plan-de-classe": [65,[4]],
		"/guide/programmation-evar-cm1-cm2": [68,[4]],
		"/guide/programmation-evar-maternelle": [69,[4]],
		"/guide/programmation-evar": [67,[4]],
		"/guide/programme-ce1-2026": [70,[4]],
		"/guide/programme-ce2-2026": [71,[4]],
		"/guide/programme-cm1-2026": [72,[4]],
		"/guide/programme-cm2-2026": [73,[4]],
		"/guide/programme-cp-2026": [74,[4]],
		"/guide/programme-emc-cp": [75,[4]],
		"/guide/programmes-2026-2027-ce-qui-change": [76,[4]],
		"/guide/progression-annuelle-cp": [78,[4]],
		"/guide/progression-annuelle": [77,[4]],
		"/guide/remplacant-ecole-primaire": [79,[4]],
		"/guide/rituels-classe": [80,[4]],
		"/guide/sciences-technologie-cm1": [81,[4]],
		"/guide/sciences-technologie-cp": [82,[4]],
		"/guide/sequence-pedagogique-vs-seance": [83,[4]],
		"/issr": [84],
		"/journal": [85],
		"/legal": [86],
		"/login": [87],
		"/pricing": [88],
		"/signup": [90],
		"/sonometre": [91],
		"/s/[token]": [89]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';